export default function SaltLakeCityStickyNav() {
  const navItems = [
    { label: "Office Info", href: "#office-info" },
    { label: "Processing", href: "#processing" },
    { label: "Local Area", href: "#local-area" },
    { label: "Services", href: "#services" },
    { label: "Travel Timing", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Facilities", href: "#facilities" },
    { label: "Compare", href: "#compare" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <div id="sticky-nav" className="bg-[#1A365D] text-white sticky top-0 z-40 hidden lg:block">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center gap-8 h-12 overflow-x-auto">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-white/80 hover:text-[#F6C344] whitespace-nowrap transition-colors py-3 border-b-2 border-transparent hover:border-[#F6C344]"
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}